import { OfferData } from 'utils/types';

export const observerElement = (
  element: HTMLElement | null,
  data: OfferData,
  sendEvent: (event: OfferData, identifier: string) => void,
  observerIdentifier: string,
) => {
  if (!element) return;
  const options = {
    threshold: 1.0,
  };
  const observer = new IntersectionObserver((entry, observer) => {
    if (!entry[0].isIntersecting) return;
    sendEvent(data, observerIdentifier);

    observer.disconnect();
  }, options);
  observer.observe(element);
};
